import { CircuitFormData } from '@/types/circuits/CircuitFormData';

export const getCircuitBenefitFirstDay = <
  T extends { steps: CircuitFormData['circuitDays'][number]['steps'] },
>(
  days: T[],
  benefit: T['steps'][number]['transport'],
) => {
  const firstDay = days.find((day) =>
    day.steps
      .flatMap((step) => [
        step.transport,
        step.accommodations,
        step.activities,
        step.meals,
      ])
      .find((step) => step?.id === benefit.id),
  );
  return firstDay ? days.indexOf(firstDay) : null;
};
